var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/isarray/index.js
// module id = 77
// module chunks = 0 1


// WEBPACK FOOTER //
// webpack:///node_modules/isarray/index.js